import React from 'react';
import Navbar from '../../components/Navbar';

const TEAM = [
  {
    name: 'Laxmikant Timilsina',
    role: 'Owner & Managing Director – Vivah Nepal Matrimony',
    residence: 'Tansen-09, Palpa | Contact & QR Payment: 9857074103',
    bio: 'Renowned marriage consultant in Nepal expertly managing matrimonial consultations, Kundali evaluation, and personalized matchmaking.',
    phone: '9857074103',
    emoji: '💍'
  },
  {
    name: 'Krishna Khanal',
    role: 'Managing Director – Sabitri Catering and Tent House',
    residence: 'Tansen-09, Palpa | Contact: 9867155395',
    bio: 'Directs Sabitri Catering and Tent House operations and Yogikuti Chowk, Butwal-10 main office for wedding feasts, buffet spreads, and mandap decor.',
    phone: '9867155395',
    emoji: '🍽️'
  },
  {
    name: 'Prakash Sharma Timilsina',
    role: 'Lead Technical Consultant & System Architect',
    residence: 'Technical Advisory | Digital Portfolio: pourkas.org',
    bio: 'Leads digital architecture, Python Django APIs, React web infrastructure, GCP cloud hosting, and technical support.',
    portfolio: 'https://pourkas.org',
    emoji: '💻'
  }
];

export default function Team() {
  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span className="badge-light">✦ Directors & Technical Advisory Board ✦</span>
          <h1 className="section-title">Leadership & Technical Advisory</h1>
          <p style={{ color: '#6E615E', maxWidth: '650px', margin: '0.4rem auto 0', fontSize: '0.92rem' }}>
            Meet our executive directors and digital architect serving Palpa, Butwal, and Lumbini province.
          </p>
        </div>

        {/* Leadership Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          {TEAM.map((member, idx) => (
            <div key={idx} className="card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontSize: '3rem', marginBottom: '0.6rem' }}>{member.emoji}</div>
                <div style={{ fontSize: '0.76rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#8C6A23', fontWeight: 800 }}>
                  {member.role}
                </div>
                <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0 0.4rem', fontFamily: 'var(--serif)' }}>
                  {member.name}
                </h3>
                <div style={{ fontSize: '0.84rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
                  📍 {member.residence}
                </div>
                <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65 }}>
                  {member.bio}
                </p>
              </div>

              <div style={{ marginTop: '1.4rem', borderTop: '1px solid #E8DFD1', paddingTop: '0.8rem' }}>
                {member.phone && (
                  <a href={`tel:${member.phone}`} className="btn btn-secondary btn-sm btn-full">
                    📞 Call {member.name.split(' ')[0]}: {member.phone}
                  </a>
                )}
                {member.portfolio && (
                  <a href={member.portfolio} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm btn-full">
                    Visit Portfolio: pourkas.org →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Corporate Office Directory */}
        <div className="card" style={{ border: '1.5px solid #D4AF37', textAlign: 'center', background: '#FFFFFF' }}>
          <span className="badge" style={{ marginBottom: '0.8rem' }}>
            🏢 Shared Corporate Headquarters
          </span>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.1rem', fontWeight: 700, color: '#9E1B32', margin: '0.4rem 0' }}>
            Yogikuti Chowk, Butwal-10, Lumbini, Nepal
          </h2>
          <p style={{ color: '#6E615E', maxWidth: '720px', margin: '0 auto 1.5rem', fontSize: '0.9rem', lineHeight: 1.7 }}>
            Visit our corporate office for matrimonial consultations with <strong>Laxmikant Timilsina (9857074103)</strong> or wedding catering & mandap decor planning with <strong>Krishna Khanal (9867155395)</strong>.
          </p>
          <div style={{ display: 'flex', gap: '0.9rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="tel:9857074103" className="btn btn-primary">
              📞 Call Matrimony: 9857074103
            </a>
            <a href="tel:9867155395" className="btn btn-secondary">
              📞 Call Catering: 9867155395
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
